export default __webpack_public_path__ + "static/media/Major Rune Stone of Quilled Darts.2918d3c4.jpg";